import { Link } from "@tanstack/react-router"

import { Button } from "@/components/ui/button"
import { Card, CardTitle } from "@/components/ui/card"
import YourCompaniesImage from "@/svg/home/your-companies.svg?react"

export function HomeCompaniesCard() {
  return (
    <Card className="@container min-w-0 overflow-hidden p-6">
      <div className="grid h-full grid-cols-1 grid-rows-[auto_1fr] gap-4 @lg:grid-cols-[auto_1fr]">
        <YourCompaniesImage className="pointer-events-none row-span-2 hidden h-full w-full @lg:block" />
        <CardTitle>Manage Companies</CardTitle>

        <div className="flex min-w-0 flex-col justify-between">
          <p className="mb-4">
            Toggle between the companies you’re supporting to help them secure
            capital efficiently. Monitor their status and manage all
            applications.
          </p>

          <Button className="bg-primary self-start" asChild>
            <Link to="/partners/companies/manage">See Summary</Link>
          </Button>
        </div>
      </div>
    </Card>
  )
}
